// console.log('Loaded: dyskinfo.js');

const dyskform = $('#dyskform');
const dyskformdiv = $('#dyskform');
const message = $('#intro-send-message');

dyskform.on('submit', function(e) {
    e.preventDefault();
    send_dyskform();
});

function send_dyskform() {
    if(typeof dysk_send_url === 'undefined') return false;

    $.ajax({
        type: 'POST',
        url: dysk_send_url,
        data: dyskform.serialize(),

        success: function(response) {
            response = JSON.parse(response);

            if(response.success) {
                message.html('<h4 class="success">' + response.success + '</h4>');
                dyskformdiv.hide();
            } else {
                message.html('<h4 class="error">' + response.error + '</h4>');
            }
        },
        error: function(error) {
            message.html('<h4 class="error">Wystąpił błąd</h4>');
        }
    })
}

